/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import { qreq } from "../../shared/qrequest";
import BaseCom from "../BaseCom";
import L from "../Lang";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class DataManager extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {};
    }

    async componentDidMount() {
        await this.load();
    }

    componentDidUpdate(prevProps) {
    }

    componentWillUnmount() {
    }

    load = async () => {
        try {
            const j = await qreq.getAsync('/api/data/model/list');
            if (j.list) {
                this.setState({ list: j.list });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    render() {
        return <div className="container-fluid">
            <h1><L>Data Manager</L></h1>
            <ul className="list-group">
                {this.state.list?.map((i, idx) => <li key={idx} className="list-group-item">
                    <Link to={i.ident}>{i.name}</Link>
                </li>)}
            </ul>
        </div>;
    }
}

export default withParamsAndNavigate(DataManager);